<template>
  <div class="streak-achieved-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <div class="streak-achieved-inner">
      <div class="streak-achieved-icon">
        <base-svg svg="streak" height="3rem" />
      </div>
      <div class="streak-stack">
        <h2>{{ opts.days }}</h2>
        <h3>Day streak achieved</h3>
      </div>
      <p>{{ opts.message }}</p>
    </div>

    <Lottie ref="lottie" :autoplay="true" animation="confetti-jump" :delay="250" />
  </div>
</template>

<script>
  import Lottie from '@/components/v5/Lottie.vue';

  export default {
    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    components: {
      Lottie,
    },

    methods: {
      close() {
        this.$emit('close');
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .streak-achieved-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    color: white;
    background-color: $neutral-100;
    background: radial-gradient(circle at bottom right, rgba($orange-tone-6, 1), rgba($neutral-100, 1) 70%);
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    max-width: 900px;
    margin: 0 auto;

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
      cursor: pointer;
      margin: 1.5rem 1.5rem 0 0;
    }

    .streak-achieved-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 1rem 1.5rem 5rem 1.5rem;
      max-width: 500px;
      margin: 0 auto;
      text-align: center;

      .streak-achieved-icon {
        margin-bottom: 1rem;

        svg {
          fill: $orange-tone-3;
        }
      }

      .streak-stack {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }

      h2 {
        font-family: 'Circular';
        font-weight: bold;
        font-size: 4rem;
        line-height: 110%;
        color: $orange-tone-3;
      }

      h3 {
        font-family: 'Circular';
        font-weight: bold;
        font-size: 1.5rem;
        line-height: 110%;
        color: $orange-tone-3;
      }

      p {
        font-size: 1.1rem;
        text-wrap: balance;
        margin-top: 1.5rem;
      }
    }
  }
</style>    